import { Notifier } from "@airbrake/browser"

const IGNORED_ERRORS = [
  "extension context invalidated",
  "failed to execute 'appendchild' on 'node': missing ) after argument list",
]

const airbrake = new Notifier({
  projectId:
    process.env.NODE_ENV === "production"
      ? process.env.AIRBRAKE_PROJECT_ID
      : "test",
  projectKey:
    process.env.NODE_ENV === "production"
      ? process.env.AIRBRAKE_API_KEY
      : "test",
})
airbrake.addFilter(notice => {
  const message = notice.errors[0].message
  if (IGNORED_ERRORS.some(ignored => message.toLowerCase().includes(ignored))) {
    return null
  }

  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.error("Airbrake called:", notice)
    return null
  }

  notice.context.environment = process.env.AIRBRAKE_ENV
  const metadata = document.querySelector("meta[name=airtutors]")?.dataset
  notice.session.user = {
    id: metadata?.id,
    type: metadata?.type,
  }
  return notice
})

export default airbrake

const reportGraphQLError = ({
  result,
  component = "Unknown",
  action = "Root Query",
  ...args
}) => {
  const params = {
    component,
    action,
    args,
    query: result.operation.query.loc.source.body,
    variables: result.operation.variables,
  }

  airbrake.notify({
    error: result.error,
    name: `${component}#${action}`,
    params,
  })

  if (process.env.NODE_ENV === "development") {
    logger.error({ result, component, action, args })
  }
}
export { reportGraphQLError }
